// extracted by mini-css-extract-plugin
export default {"upgradeWrapper":"LeadDestination-module-upgradeWrapper-3l-ll","leadWrapper":"LeadDestination-module-leadWrapper-ekqQC","disabledText":"LeadDestination-module-disabledText-1U_eC"};